import React, { useEffect, useState } from "react";

import NoDataFound from "./NoDataFound";
import NextImage from "./NextImage";
import { loadStyles } from "../../utils/cssLoader";
const TopScorers = ({ data, loadCSS, dataClient = false, title }) => {
  const [clientData, setClientData] = useState(null);
  useEffect(() => {
    if (!dataClient) return;

    const container = document.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data?.data;
      setClientData(parsed || null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);
  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("leaguetopscrorers");
    }
  }, [loadCSS]);
  const sourceData = dataClient ? clientData : data;
  return (
    <div className="top_score_wrp">
      {sourceData?.length ? (
        <>
          <div className="top_score_hd">
            <h2>Goals</h2>
            <strong className="hd_rgt">PEN</strong>
            <strong className="hd_rgt">GS</strong>
          </div>
          <ul className="item_list">
            {sourceData?.map((i) => (
              <li key={i?.id}>
                <span className="num"></span>
                <div className="country_info">
                  <div className="flag_img">
                    <NextImage
                      src={`https://img.sixlogics.com/players/${i?.player?.id}.png`}
                      width={18}
                      height={18}
                      alt="avtar"
                    />
                  </div>
                  <strong className="cr_name">
                    {i?.pn || i?.player?.name}
                  </strong>
                </div>
                <span className="g_num">{i?.pc}</span>
                <span className="g_num">{i?.gs}</span>
              </li>
            ))}
          </ul>
        </>
      ) : (
        <div className="top_score_hd">
          <NoDataFound />
        </div>
      )}
    </div>
  );
};

export default TopScorers;
